import api from "./api";

/**
 * The coach's three goal writes, as the requests alone (#1221 slice 2, D57).
 *
 * `CoachPortal.jsx` owns the state these close over and the shipped page's
 * handlers (`saveGoal`, `saveGoalProgress`, `deleteGoal`), which wrap each of
 * these with the toast and the `confirm()` they have always had. The coach's
 * player page calls them as they are: each THROWS on failure and toasts
 * nothing, so the panel that asked can show the failure where it happened
 * instead of a toast that goes away. Lifted out of the page because that
 * function is exactly at its line budget (`eslint.config.mjs`).
 *
 * `loadGoals` reloads the list after a write; it never throws (the page's
 * `guardedLoad` catches), so a write that succeeded is not reported failed
 * because the reload did.
 */
export function coachGoalWrites({ selected, newGoal, editingGoal, setEditingGoal, setGoalDialog, loadGoals }) {
  const createGoal = async () => {
    await api.post("/goals", { ...newGoal, player_id: selected.player_id });
    setGoalDialog(false);
    loadGoals();
  };

  const putGoalProgress = async () => {
    if (!editingGoal) return;
    await api.put(`/goals/${editingGoal.goal_id}`, {
      progress_percentage: editingGoal.progress_percentage,
      status: editingGoal.status,
    });
    setEditingGoal(null);
    loadGoals();
  };

  const removeGoal = async (g) => {
    await api.delete(`/goals/${g.goal_id}`);
    loadGoals();
  };

  return { createGoal, putGoalProgress, removeGoal };
}
